let index: number = 0;

const CureFormByStoreGridPluginSettings: IPluginSettings = {
    name: 'Лекарственная форма',
    mnemocode: 'cure_form_by_store_plugin',
    permission: 'RequestForMovement',
    columns: [{
        order: index++,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'ИД',
        visibility: false,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'cureFormName',
        propertyType: 'string',
        displayName: 'Лекарственная форма',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }],
}

export default CureFormByStoreGridPluginSettings